import extend from 'extend';
import type { IEnv } from '../../types/types';

interface StringExpression {
  qStringExpression: {
    qExpr: string;
  };
}

export default {
  createDefaultListBox(
    dimensionDef: EngineAPI.IListObjectDef,
    title: string | StringExpression | undefined,
    env: IEnv,
  ) {
    let newTitle: string | StringExpression | undefined = title;
    const listboxDef = extend(true, {}, dimensionDef);
    let i;
    listboxDef.qShowAlternatives = true;
    for (i = 0; i < listboxDef.qDef.qSortCriterias!.length; ++i) {
      listboxDef.qDef.qSortCriterias![i].qSortByState = 1;
    }

    if (env.flags?.isEnabled('QCB-35224_FILTERPANE_TITLE_IMPROVEMENT')) {
      if (newTitle === '') {
        newTitle = undefined;
      }
    } else {
      // oxlint-disable-next-line no-lonely-if
      if (!newTitle && dimensionDef.qDef.qLabelExpression) {
        newTitle = {
          qStringExpression: {
            qExpr: dimensionDef.qDef.qLabelExpression,
          },
        };
      } else if (
        !newTitle &&
        (!dimensionDef.qDef.qFieldLabels ||
          !dimensionDef.qDef.qFieldLabels.length ||
          dimensionDef.qDef.qFieldLabels[0] === '')
      ) {
        [newTitle] = dimensionDef.qDef.qFieldDefs ?? [];
      } else {
        newTitle =
          newTitle ||
          (dimensionDef.qDef.qFieldLabels && dimensionDef.qDef.qFieldLabels.length
            ? dimensionDef.qDef.qFieldLabels[0]
            : '');
      }
    }

    return {
      qInfo: {
        qType: 'listbox',
      },
      qListObjectDef: listboxDef,
      title: newTitle,
      visualization: 'listbox',
    };
  },
};
